export const FOLLOWUP_STAMPS_TOOLS = 'FollowupStampsTools';
